import type { DSFocusable } from "@/src/design_system/shared/types/expose";

type FocusableTargetRef = {
  readonly value: DSFocusable | null | undefined;
};

export const useDSInput = (target?: FocusableTargetRef): DSFocusable => {
  const focus = () => {
    target?.value?.focus();
  };

  const blur = () => {
    target?.value?.blur();
  };

  return { focus, blur };
};
